import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'

export default class Proof extends JsonApiObject {
    challenge
    expiresAt
    invalidSecret = false
    retryAfter

    public constructor(data: any) {
        super(data)
    }

    static async initiateProof(claim, language) {
        let query = {
            body: {
                data: {
                    type: 'proof',
                    attributes: {
                        claim,
                        language,
                    },
                },
            },
        }

        let res = await Vue.prototype.$vbit.post('authentication', `proofs`, query)

        if (res.data) {
            res.data.attributes.retryAfter = res.headers['retry-after']
            res = new Proof(res.data)
        }

        return res
    }

    async completeProof(secret) {
        let query = {
            body: {
                data: {
                    type: this._type,
                    id: this._id,
                    attributes: {
                        secret,
                    },
                },
            },
        }

        let res = await Vue.prototype.$vbit.patch('authentication', `proofs/${this._id}`, query)

        return res
    }
}
